var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _polygon, _polygon2, _polygon3, _polygon4, _path, _rect6, _polygon5, _polygon6, _polygon7, _polygon8, _path2, _rect7, _polygon9, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _polygon10, _polygon11, _polygon12, _polygon13, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _polygon14, _rect21, _g, _ellipse, _ellipse2, _g2, _g3, _path11, _g4, _g5, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _polygon15, _polygon16, _polygon17, _rect22, _rect23, _polygon18, _polygon19, _polygon20, _rect24, _rect25, _rect26, _g6, _path19, _g7, _rect27, _rect28, _polygon21, _path20, _rect29, _g8, _g9, _path21, _g10, _g11, _g12, _rect30, _path22, _path23, _path24, _path25, _path26, _path27, _g13, _path28, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _path29, _path30, _path31, _path32, _path33, _ellipse3, _path34, _path35, _path36, _polygon22, _polygon23, _polygon24, _path37, _polygon25, _g21, _g22, _path38, _path39, _polygon26, _path40;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomesecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "*, ::after, ::before { box-sizing: border-box; }\nimg, svg { vertical-align: middle; }\n"), /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "*, body, html { -webkit-font-smoothing: antialiased; }\nimg, svg { max-width: 100%; }\n"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 547.45,
    y: 37.06,
    width: 267.06,
    height: 352.84,
    fill: "#ebebeb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 686.31,
    y: 51.21,
    width: 115.65,
    height: 156.95,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 559.96,
    y: 51.21,
    width: 115.65,
    height: 156.95,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 686.31,
    y: 218.83,
    width: 115.65,
    height: 156.95,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 559.96,
    y: 218.83,
    width: 115.65,
    height: 156.95,
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "636.67 37.08 547.43 37.08 547.43 541.87 599.08 541.87 563.04 285.01 636.67 37.08",
    fill: "#dbdbdb"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "621.21 50.73 607.1 109.39 592.72 168.01 563.93 285.23 563.95 284.9 577.26 407.41 583.89 468.65 590.23 529.93 582.99 468.74 576.02 407.54 562.12 285.1 562.1 284.95 562.13 284.79 591.53 167.71 606.23 109.19 621.21 50.73",
    fill: "#ebebeb"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "552.75 61.07 553.2 111.69 553.46 162.34 553.68 263.58 553.46 364.83 553.2 415.45 552.75 466.07 552.29 415.45 552.03 364.83 551.83 263.58 552.03 162.34 552.29 111.69 552.75 61.07",
    fill: "#ebebeb"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "569.42 70.56 566.69 124.37 563.78 178.18 557.68 285.77 557.68 285.69 560.65 405.57 561.95 465.52 563.04 525.47 561 465.54 559.17 405.61 555.87 285.73 555.87 285.69 555.87 285.66 562.41 178.09 565.84 124.33 569.42 70.56",
    fill: "#ebebeb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M581,517.7l-5.88-58.08-5.69-58.09c-3.61-38.74-7.41-77.46-10.88-116.22v-.24l16.57-90.46,8.42-45.21,8.55-45.18-7.79,45.32-7.92,45.29-16.08,90.55v-.24c3.7,38.74,7.11,77.5,10.69,116.26l5.1,58.13Z",
    fill: "#ebebeb"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 547.45,
    y: 280.76,
    width: 20.15,
    height: 11.77,
    fill: "#dbdbdb"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "725.05 37.08 814.29 37.08 814.29 541.87 762.64 541.87 798.7 285.01 725.05 37.08",
    fill: "#dbdbdb"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "740.51 50.73 755.49 109.19 770.19 167.71 799.59 284.79 799.62 284.95 799.61 285.1 785.7 407.54 778.73 468.74 771.49 529.93 777.82 468.65 784.48 407.41 797.77 284.9 797.79 285.23 769 168.01 754.62 109.39 740.51 50.73",
    fill: "#ebebeb"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "808.97 61.07 809.43 111.69 809.69 162.34 809.89 263.58 809.69 364.83 809.43 415.45 808.97 466.07 808.52 415.45 808.26 364.83 808.06 263.58 808.26 162.34 808.52 111.69 808.97 61.07",
    fill: "#ebebeb"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "792.3 70.56 795.9 124.33 799.31 178.09 805.85 285.66 805.85 285.69 805.85 285.73 802.55 405.61 800.72 465.54 798.7 525.47 799.79 465.52 801.07 405.57 804.03 285.69 804.03 285.77 797.94 178.18 795.04 124.37 792.3 70.56",
    fill: "#ebebeb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M780.68,517.7l4.91-58.17,5.12-58.13c3.56-38.76,7-77.52,10.67-116.26v.24l-16-90.55-7.91-45.29-7.79-45.32,8.56,45.18,8.42,45.21,16.55,90.45v.25c-3.48,38.76-7.26,77.48-10.9,116.22l-5.67,58.09Z",
    fill: "#ebebeb"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 794.14,
    y: 280.78,
    width: 20.15,
    height: 11.77,
    fill: "#dbdbdb"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "58.44 599.35 403.91 599.35 411.08 457.61 51.25 457.61 58.44 599.35",
    fill: "#ebebeb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M387.52,522.48H243.11l-2.71-49.21H390.67Zm-142.73-1.74H385.93L388.82,475H242.23Z",
    fill: "#dbdbdb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M384.85,579.08H248.76l-2.21-44.49H387.63Zm-134.44-1.75H383.26l2.52-40.89H248.39Z",
    fill: "#dbdbdb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M329.23,503.22H305l-1.54-11.88h27.33Zm-22.75-1.74h21.17l1.08-8.4H305.41Z",
    fill: "#dbdbdb"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M329.23,562.82H305L303.42,551h27.33Zm-22.75-1.74h21.17l1.08-8.38H305.41Z",
    fill: "#dbdbdb"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M217.65,522.48H73.22l-2.71-49.21h150.3ZM74.92,520.74H216.06L219,475H72.35Z",
    fill: "#dbdbdb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M215,579.08H78.87l-2.2-44.49h141.1ZM80.54,577.33h132.8l2.55-40.89H78.5Z",
    fill: "#dbdbdb"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M159.34,503.22H135.07l-1.53-11.88h27.28Zm-22.73-1.74H157.8l1.09-8.4H135.52Z",
    fill: "#dbdbdb"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M159.34,562.82H135.07L133.54,551h27.28Zm-22.73-1.74H157.8l1.09-8.38H135.52Z",
    fill: "#dbdbdb"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "89.42 599.35 87.25 614.79 82.89 645.83 74.37 645.83 74.37 599.35 89.42 599.35",
    fill: "#ebebeb"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "89.42 599.35 87.25 614.79 74.37 614.79 74.37 599.35 89.42 599.35",
    fill: "#dbdbdb"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "372.92 599.35 375.08 614.79 379.46 645.83 387.99 645.83 387.99 599.35 372.92 599.35",
    fill: "#ebebeb"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "372.92 599.35 375.08 614.79 387.99 614.79 387.99 599.35 372.92 599.35",
    fill: "#dbdbdb"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 78.01,
    y: 71.13,
    width: 104.66,
    height: 126.96,
    fill: "#ebebeb"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 89.97,
    y: 82.74,
    width: 80.75,
    height: 103.79,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 89.97,
    y: 82.74,
    width: 3.15,
    height: 103.79,
    fill: "#dbdbdb"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 182.67,
    y: 71.13,
    width: 3.15,
    height: 126.96,
    fill: "#dbdbdb"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 117.03,
    y: 97.03,
    width: 19.04,
    height: 56.72,
    fill: "#dbdbdb"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 108.73,
    y: 135.66,
    width: 50.77,
    height: 27.79,
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 174.37,
    y: 228.9,
    width: 104.66,
    height: 126.96,
    fill: "#ebebeb"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 186.32,
    y: 240.48,
    width: 80.75,
    height: 103.79,
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 186.32,
    y: 240.48,
    width: 3.15,
    height: 103.79,
    fill: "#dbdbdb"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 279.02,
    y: 228.9,
    width: 3.15,
    height: 126.96,
    fill: "#dbdbdb"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 218.87,
    y: 267.31,
    width: 16.31,
    height: 41.24,
    fill: "#ebebeb"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 208.55,
    y: 292.37,
    width: 43.82,
    height: 28.44,
    fill: "none",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 446.16,
    y: 82.71,
    width: 5.86,
    height: 16.28,
    transform: "translate(898.18 181.7) rotate(-180)",
    fill: "#bcbec0"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "444.86 103.33 392.12 83.79 392.12 90.96 444.43 109.62 444.86 103.33",
    fill: "#bcbec0"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 464.78,
    y: 44.05,
    width: 45.03,
    height: 51.6,
    rx: 3.57,
    transform: "translate(974.58 139.69) rotate(-180)",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 470.84,
    y: 49.86,
    width: 33.04,
    height: 40.21,
    transform: "translate(974.72 139.92) rotate(-180)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 487.59,
    cy: 70.08,
    rx: 10.48,
    ry: 11.79,
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 487.47,
    cy: 70.25,
    rx: 4.67,
    ry: 5.01,
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.58,71l-1,0a7.1,7.1,0,0,0-6.83-7.46l.09-1C494.85,63.18,494.58,70.88,494.58,71Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 500.76,
    y: 52.25,
    width: 1,
    height: 12.64
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M535.44,43.84l-56.36.53L464.74,57.76V91.37a4.48,4.48,0,0,0,4.31,4.27s-2.37.69-8-3.58L413.54,62.67V33.79l18.63-2.56Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.21,44.34h-.07l-65.67-10a.5.5,0,0,1-.42-.57.5.5,0,0,1,.57-.42l65.67,10.05a.5.5,0,0,1,.42.56A.51.51,0,0,1,479.21,44.34Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "464.75 57.76 454.21 67.46 413.54 48.4 413.54 52.76 453.75 70.02 464.75 57.76"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M445.65,97h6.67a3.83,3.83,0,0,1,3.83,3.83v12.45a0,0,0,0,1,0,0H441.82a0,0,0,0,1,0,0V100.86A3.83,3.83,0,0,1,445.65,97Z",
    transform: "translate(897.97 210.34) rotate(-180)",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M450.16,82s3.07,2.66-5.33,3.48a83,83,0,0,1-12.51.68,5.58,5.58,0,0,0-3,.78c-4.56,2.74-17.91,11.36-24,15.27l-3.05,2,.08-1.93a13.38,13.38,0,0,0,1.16-3.66l2.79-17.5,1.35-.69L427,70.66a8.72,8.72,0,0,0,1.53-1c1.11-.9,3.79-2.48,7.48-.33a1.75,1.75,0,0,0,.83.25c1.28,0,5,.15,7.34,0,0,0,2.44-.25,2.54,1.36A1.67,1.67,0,0,1,445,72.6h-3.79a1,1,0,1,0,0,2h0l5.57-.13a7,7,0,0,1,5.19,2C453.5,78,454.21,80.12,450.16,82Z",
    fill: "#f9b499"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M435.18,85.88a.52.52,0,0,1-.33-.12c-4.33-3.72-3.72-7.7-3.37-9-2.74-1.8-1.75-5.58-.8-7.39a.5.5,0,1,1,.88.47c-.1.18-2.35,4.59.75,6.25a.5.5,0,0,1,.23.63c-.08.17-1.69,4.27,3,8.26a.5.5,0,0,1-.32.88Z",
    fill: "#f7a48b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M440.66,77.76a.49.49,0,0,1-.49-.46.5.5,0,0,1,.46-.54L452,76a.5.5,0,0,1,.07,1l-11.37.75Z",
    fill: "#f7a48b"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M441.62,80.87a.51.51,0,0,1-.5-.49.5.5,0,0,1,.49-.51l11.22-.24h0a.5.5,0,0,1,.5.49.51.51,0,0,1-.49.51l-11.22.24Z",
    fill: "#f7a48b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M442.1,83.25a.49.49,0,0,1-.5-.45.51.51,0,0,1,.45-.55l8.07-.71a.51.51,0,0,1,.54.45.5.5,0,0,1-.46.54l-8.06.72Z",
    fill: "#f7a48b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M407.7,80.46a92.36,92.36,0,0,0-2.33,21.79l-3.05,2,.08-1.93a13.38,13.38,0,0,0,1.16-3.66l2.79-17.5Z",
    fill: "#f7a48b"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "408.52 379.51 314.64 643.64 319.42 643.64 405.82 408.31 408.52 379.51",
    fill: "#bcbec0"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "348.53 621.06 325.06 621.06 325.06 618.4 349.86 618.4 348.53 621.06",
    fill: "#a7a9ac"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "365.72 572.28 342.48 572.39 342.48 569.72 366.8 569.65 365.72 572.28",
    fill: "#a7a9ac"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 378.14,
    y: 515.49,
    width: 17.9,
    height: 5.58,
    fill: "#d1d3d4"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 357,
    y: 515.49,
    width: 21.14,
    height: 5.58,
    fill: "#bcbec0"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "383.12 523.69 359.71 523.75 359.71 521.08 384.02 521.01 383.12 523.69",
    fill: "#a7a9ac"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "399.18 478.9 375.94 479.01 376.14 476.09 400.55 475.97 399.18 478.9",
    fill: "#a7a9ac"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "435.89 391.12 514.66 648.42 506.06 648.42 432.79 400.27 435.89 391.12",
    fill: "#bcbec0"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 399.81,
    y: 426.08,
    width: 75.02,
    height: 5.14,
    fill: "#a7a9ac"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 373.46,
    y: 439.34,
    width: 19.5,
    height: 11.14,
    fill: "#f9b499"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 370.24,
    y: 466.69,
    width: 55.39,
    height: 3.92,
    fill: "#0071f2",
    "data-primary": "true"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 370.24,
    y: 466.69,
    width: 55.39,
    height: 3.92
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M373.22,445.19l-3,21.5h55.4a5.44,5.44,0,0,0-3.63-4.9c-6-2.11-18.4-7.2-26.45-15.52a9.41,9.41,0,0,0-9.53-2.59c-1.75.56-3.1,1.64-2.92,3.7C383.11,447.38,379.5,448.48,373.22,445.19Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.74,458.87a.59.59,0,0,1-.22-.05,94.83,94.83,0,0,1-16.74-11.06.49.49,0,0,1,0-.7.5.5,0,0,1,.7-.06A93.6,93.6,0,0,0,400,457.92a.51.51,0,0,1,.22.67A.49.49,0,0,1,399.74,458.87Z"
  }))), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 394.01,
    y: 470.58,
    width: 17.9,
    height: 5.58,
    fill: "#d1d3d4"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 372.87,
    y: 470.58,
    width: 21.14,
    height: 5.58,
    fill: "#bcbec0"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "410.69 381.87 403.25 398.9 418.13 403.86 421.6 401.04 425.56 393.61 421.43 385.34 410.69 381.87",
    fill: "#f9b499"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M453,418.07l-56.53-.33s-2-26.78,11.9-18.84l9.26,3s0-6.86,4.22-6.72a2.64,2.64,0,0,1,2.49,2.74l-.1,2.82,24,12.07S453.34,415.26,453,418.07Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 396.47,
    y: 417.74,
    width: 56.7,
    height: 4.46,
    fill: "#0071f2",
    "data-primary": "true"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396.47,
    y: 417.74,
    width: 56.7,
    height: 4.46
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426,408.65a.47.47,0,0,1-.3-.1l-8.4-6.28a.5.5,0,1,1,.6-.8l8.4,6.28a.5.5,0,0,1-.3.9Z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M417.48,266.32,466.12,307s9.23,9.55-4.45,38.82c0,0-16.23,38.19-29.6,50,0,0-17.18-4.14-23.55-16.23l17.83-50.92L413,320S416.8,282.79,417.48,266.32Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.48,266.32l5.4,4.39-3.45,53.36L413,320S416.6,283.62,417.48,266.32Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.77,313.34a.59.59,0,0,1-.22,0c-.69-.34-16.9-8.28-22.87-17.36a.5.5,0,0,1,.14-.69.49.49,0,0,1,.69.14c5.83,8.85,22.31,16.93,22.48,17a.5.5,0,0,1,.23.67A.52.52,0,0,1,443.77,313.34Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.23,385.42l-.12,0a.48.48,0,0,1-.36-.6,138.82,138.82,0,0,1,19.61-44.2,7.85,7.85,0,0,0,1.42-5.35,3.19,3.19,0,0,1,.7-2.86,2.06,2.06,0,0,1,1.59-.49c1.89-.83,3-1.73,3.12-2.62a2.08,2.08,0,0,0-.83-1.74,5.77,5.77,0,0,1-1.5-2,2.34,2.34,0,0,1,0-2.41c.49-.65,1.47-.88,2.9-.69a2.44,2.44,0,0,0,2.06-.63,1.35,1.35,0,0,0,.46-1.12c-.1-1-1.4-2.07-1.89-2.39a.5.5,0,0,1,.55-.84c.09.06,2.16,1.42,2.34,3.12a2.36,2.36,0,0,1-.75,1.94,3.46,3.46,0,0,1-2.9.91c-1-.13-1.73,0-2,.31s-.07,1,.12,1.42A4.69,4.69,0,0,0,444,326.8a2.93,2.93,0,0,1,1.14,2.65c-.21,1.27-1.5,2.42-3.83,3.42a.52.52,0,0,1-.3,0,1.15,1.15,0,0,0-.9.23,2.4,2.4,0,0,0-.37,2,8.84,8.84,0,0,1-1.59,6A137.91,137.91,0,0,0,418.72,385,.51.51,0,0,1,418.23,385.42Z"
  }))), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 438.82,
    y: 98.36,
    width: 24.87,
    height: 1,
    transform: "translate(325.24 543.3) rotate(-86.53)",
    fill: "#e6e7e8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M448.66,110.32s-3.46-3.1-5-1.19c0,0-1.67,2.38,3.94,6.32Z",
    fill: "#f9b499"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43,116.84s-5.09-1.51-3.66,2.67a3.56,3.56,0,0,0,0,5.13,5,5,0,0,0,1.91,6.13Z",
    fill: "#f9b499"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M439.73,150.7h0a3.6,3.6,0,0,0,4.56-1.88l3.53-9.16a34.71,34.71,0,0,0,2.13-8.8l2.13-18s7.21,4.22,6.86,11.29l2.12,41.31A23.15,23.15,0,0,1,460,174c-1.79,5.44-6.3,11.81-17.61,7.07l-17.73-7.49s11.72-4.61,15.06-22.87Z",
    fill: "#f9b499"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M452.6,158.67a.45.45,0,0,1-.31-.11l-9-7.28a.49.49,0,1,1,.62-.77l9,7.27a.51.51,0,0,1,.08.71A.5.5,0,0,1,452.6,158.67Z",
    fill: "#f7a48b"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M440.19,148.86C436.37,173.93,419,175.6,419,175.6l-1.44,30.55-63.72-1s-.24-29.49,1-45.19a66.81,66.81,0,0,0-3.38-27.5c-4.08-18,17.67-23.61,19.83-24.21h0v4.83l0,2.37c0,.28,0,.54,0,1.09v.7a9.79,9.79,0,1,0,19.57,0v-3.77l.16,0,16.24,7.87A61.26,61.26,0,0,1,423,131.2Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M361.39,114.18a18.13,18.13,0,0,0-3.78,13.44s4.77,36.28,5.49,45.59l-5.73-.24s-10.5,40.58.95,76.86a165.82,165.82,0,0,1,12.89,59.9l-1.67,131.52,31-1.91S413,320,416.8,284.2c0,0,3.51-54.17,3.83-74.48a5.27,5.27,0,0,0-4.9-5.35c-7-.52-20.08-2.82-28.29-12.54a42.27,42.27,0,0,1-6.68-17.66h-2.87s-2.38-32.23,30.32-52.51l-7.4-3.34s-21.25,5.49-31.51,38L365,129.77s-.9-12.38,6.26-18.35l0-3.13s-.31.11-1.49.45A16.66,16.66,0,0,0,361.39,114.18Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.3,173.39a.5.5,0,0,1-.5-.5V156.27a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v16.62A.5.5,0,0,1,369.3,173.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.89,174.67h0l-14.8-.95a.5.5,0,0,1-.46-.53.51.51,0,0,1,.53-.47l14.8,1a.49.49,0,0,1,.46.53A.5.5,0,0,1,377.89,174.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,176.1a.57.57,0,0,1-.3-.1l-17.82-13.21a.5.5,0,1,1,.59-.8l17.83,13.21a.5.5,0,0,1-.3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.31,171.25a.51.51,0,0,1-.44-.26.5.5,0,0,1,.2-.68c17.86-9.75,17.17-24.92,17.17-25.07a.49.49,0,0,1,.46-.53.52.52,0,0,1,.53.47c0,.15.76,15.94-17.68,26A.44.44,0,0,1,418.31,171.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,146.66a.51.51,0,0,1-.31-.11.5.5,0,0,1-.07-.71c12.82-15.66,22-19.78,22.38-20a.5.5,0,0,1,.66.26.5.5,0,0,1-.26.66c-.09,0-9.37,4.22-22,19.67A.5.5,0,0,1,394,146.66Z"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M390.86,97v20.29a9.79,9.79,0,1,1-19.57,0v-4.16l0-2.84s0-1.59,0-2V97Z",
    fill: "#f9b499"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.89,260.05a.5.5,0,0,1-.33-.12l-9.18-8.07a.52.52,0,0,1-.16-.41l1.1-19.81a.51.51,0,0,1,.52-.47.5.5,0,0,1,.47.53l-1.08,19.57L380,259a46.13,46.13,0,0,0,8.07-3.89c.87-.53,1.73-1.09,2.57-1.68a10.42,10.42,0,0,0,4.4-8.5,84.79,84.79,0,0,1,1.83-17.51c-8.8-.08-23.12-1.82-23.27-1.84a.5.5,0,0,1-.44-.55.51.51,0,0,1,.56-.44c.15,0,15.11,1.83,23.78,1.83a.49.49,0,0,1,.4.2.51.51,0,0,1,.09.43,80.57,80.57,0,0,0-2,17.88,11.44,11.44,0,0,1-4.83,9.32c-.85.6-1.73,1.17-2.62,1.71a47.28,47.28,0,0,1-8.52,4.08Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.8,275.83h0a.49.49,0,0,1-.47-.53l4-63.83a.48.48,0,0,1,.53-.46.49.49,0,0,1,.46.53l-4,63.83A.51.51,0,0,1,411.8,275.83Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406,325.59a.46.46,0,0,1-.33-.13c-5.64-5-16.38-12-16.49-12a.5.5,0,0,1-.23-.42V275.13a.53.53,0,0,1,.18-.39.49.49,0,0,1,.4-.11c.17,0,16.59,2.82,27.51.64a.51.51,0,0,1,.59.39.5.5,0,0,1-.4.59c-9.91,2-24.23-.06-27.28-.54v37A177.05,177.05,0,0,1,406,324.45l6.68-4.86a.5.5,0,0,1,.69.11.49.49,0,0,1-.11.7l-7,5.09A.46.46,0,0,1,406,325.59Z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.67,292.45a70.18,70.18,0,0,1-17.37-1.88A.5.5,0,0,1,389,290a.5.5,0,0,1,.61-.35c10.3,2.81,24.51,1.59,24.65,1.58a.51.51,0,0,1,.54.45.5.5,0,0,1-.45.54C414.23,292.18,411.08,292.45,406.67,292.45Z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.13,433.69a91,91,0,0,1-12.51-.86.51.51,0,0,1-.42-.57.52.52,0,0,1,.57-.42c.21,0,21,3.09,31.83-2.81a.5.5,0,1,1,.48.88C396.54,432.92,388.71,433.69,382.13,433.69Z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.16,432.52l-.15,0a.5.5,0,0,1-.33-.62c6.59-21.65,10.76-106,10.8-106.8a.46.46,0,0,1,.52-.48.5.5,0,0,1,.48.52c0,.85-4.22,85.29-10.84,107.05A.51.51,0,0,1,395.16,432.52Z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.28,388.76h-.1c-15.74-3.1-27.37-16.5-27.49-16.63a.51.51,0,0,1,.06-.71.49.49,0,0,1,.7.06c.11.13,11.53,13.27,26.93,16.3a.5.5,0,0,1,.39.59A.51.51,0,0,1,438.28,388.76Z"
  }))), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 343.06,
    y: 612.68,
    width: 17.9,
    height: 5.58,
    fill: "#d1d3d4"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 321.92,
    y: 612.68,
    width: 21.14,
    height: 5.58,
    fill: "#bcbec0"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 360.96,
    y: 564.18,
    width: 17.9,
    height: 5.58,
    fill: "#d1d3d4"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 339.82,
    y: 564.18,
    width: 21.14,
    height: 5.58,
    fill: "#bcbec0"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 413.01,
    y: 422.59,
    width: 66.4,
    height: 5.69,
    fill: "#d1d3d4"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 404.39,
    y: 422.22,
    width: 8.62,
    height: 6.05,
    fill: "#bcbec0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M448,139h0a3.35,3.35,0,0,1-3-3.76L448.26,110l4.24.42-.89,25.41A3.34,3.34,0,0,1,448,139Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M378.23,66a3,3,0,0,1-1.68-.41,1.23,1.23,0,0,1-.58-1,.26.26,0,0,1,.25-.25.25.25,0,0,1,.25.25.75.75,0,0,0,.38.55c.56.36,2.17.73,6.68-1a.27.27,0,0,1,.33.14.26.26,0,0,1-.15.33A16.67,16.67,0,0,1,378.23,66Zm-1.76-1.36h0Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M390.86,113.51l-.08-4-10.66-8.27S380,110.3,390.86,113.51Z",
    fill: "#f7a48b"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M406.35,81.14l-2.79,17.5a12.8,12.8,0,0,1-1.16,3.67,12.94,12.94,0,0,1-13.63,7l-.29,0a12.92,12.92,0,0,1-10.72-14.79l2.8-17.5a12.89,12.89,0,0,1,14.79-10.71l.29,0A12.91,12.91,0,0,1,406.35,81.14Z",
    fill: "#f9b499"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M366,81.56H365a2.6,2.6,0,0,1-2.57-2.89c.3-3,2-8.08,8.75-14.53,0,0-4.53-5,7.64-3.82,0,0,2.34-3.4,9.62-4.19a1.06,1.06,0,0,1,1.16,1.21l-.28,1.78s17.9-1.91,17.42,5.73c0,0,6.21,3.82,6.45,9.79l-4.3-.24s1,8.83-5.49,5c0,0,.72,5-1.43,6.45,0,0-1.67.47-1.91,6.44V98l3.47.61s1.49,16.81-18.9,9.44c0,0,12.81-.74,13-15.78l-5.49-2.86s2.39,5.72-4.53,10.26l-12.41,6.92s-3.58-.48-4.06-7.4c0,0-2.39-.24-2.39-5.73C368.82,93.49,362.62,96.12,366,81.56Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 396.03,
    cy: 88.12,
    rx: 4.06,
    ry: 5.13,
    fill: "#f9b499"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M454.19,137.41s-8.87-2.39-6.84-10.74c0,0,.68-5-.06-7.79a.78.78,0,0,1,.71-1c1.68-.07,5,.93,6.87,9.39",
    fill: "#f9b499"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M442.26,373.78s9.23-3.5,13.36,8.59l82.9,266.52h6.21L463.58,384.44s-4.77-18.62-19.33-16.47Z",
    fill: "#bcbec0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M341.49,641.24,465.92,288.66a1.56,1.56,0,0,0-1.43-2.08l-16.19-.47-1.79,4.41-4.65-4.06,3.94-7.16h27.37a1.57,1.57,0,0,1,1.48,2.09L347.1,643.17Z",
    fill: "#bcbec0"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "348.89 649.52 337.61 649.39 340.46 640.96 349.02 643.81 348.89 649.52",
    fill: "#a7a9ac"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "322.31 649.52 311.02 649.39 313.88 640.96 322.44 643.81 322.31 649.52",
    fill: "#a7a9ac"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "456.37 606.97 554.74 606.97 549.74 651.66 461.61 651.66 456.37 606.97",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M474.22,609.85,445.83,627.1a4.17,4.17,0,0,0,1.69,7.7l12.27,1.34-.77-6.55-4.08,0a.54.54,0,0,1-.29-1l22.41-14.2a2.7,2.7,0,0,0,.53-4.12h0A2.71,2.71,0,0,0,474.22,609.85Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "457.51 616.65 447.21 616.65 433.23 571.23 440.57 558.29 464.15 559.17 468.35 554.8 488.79 554.8 486.87 560.92 506.61 560.57 528.28 607.04 456.37 606.97 457.51 616.65",
    fill: "#0071f2",
    "data-primary": "true"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "449.3 571.4 458.39 603.2 455.77 603.2 443.71 560.74 465.73 561.09 469.57 555.85 488.44 556.2 486 562.84 504.87 562.84 525.66 607.04 513.08 607.04 498.93 572.45 449.3 571.4"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "456.37 606.97 447.21 616.65 457.51 616.65 456.37 606.97"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M481,589.41a4.36,4.36,0,0,0-5.91-1.56l0,0a4.35,4.35,0,0,0-1.51,6.09l8.07,13,9.9,0Zm-.46,7.84c-1,.57-2.66-.41-3.69-2.21s-1.07-3.72-.07-4.3,2.66.41,3.7,2.2S481.56,596.67,480.56,597.25Z",
    fill: "#f1f2f2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M481.79,606.87l-.16.13H479l-6.45-11.09c-3.29-5,2-7.79,2.54-8a4.35,4.35,0,0,0-1.51,6.09l8.07,12.91Z",
    fill: "#e6e7e8"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "524.15 564.71 529.21 566.07 513.08 607.04 506.83 607.04 524.15 564.71",
    fill: "#f1f2f2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M516.16,607l15-16.47a2.9,2.9,0,0,1,4.08-.22l8.26,7.28a3.13,3.13,0,0,1,0,4.66h0a3.13,3.13,0,0,1-4.21,0l-3.33-3a2.91,2.91,0,0,0-4.09.19l-7,7.61Z",
    fill: "#d1d3d4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomesecurity);
export default __webpack_public_path__ + "static/media/home security.200a06b48b20e6468fffe412212a9b91.svg";
export { ForwardRef as ReactComponent };